module.exports = __webpack_public_path__ + "static/media/seriousCallDoctor.d4236bab.mp3";